import React, { useEffect } from 'react';
import { useHasMounted } from '@growth/custom-hooks/useHasMounted';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var ModalOverlay = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1030;\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\toutline: 0;\n\tbackground: rgb(0 0 0 / 48%);\n\ttouch-action: none;\n"])));
var ConfirmationModalContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: #fff;\n\tbox-shadow: 0 24px 24px rgba(0, 0, 0, 0.3), 0 0 24px rgba(0, 0, 0, 0.22);\n\tborder-radius: 8px;\n\tposition: fixed;\n\ttop: 38%;\n\tright: 20px;\n\tleft: 20px;\n\tz-index: 1031;\n"])));
var ModalHeader = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tline-height: 24px;\n\tmargin-bottom: 15px;\n"])));
var ModalContent = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tfont-size: 14px;\n\tline-height: 24px;\n\tcolor: #777;\n\ttext-align: center;\n"])));
var TextContentDiv = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\ttext-align: center;\n\tpadding: 21px 41px;\n"])));
var BtnWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n"])));
var Btn = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex: 1;\n\talign-items: center;\n\tpadding: 22px 0;\n\tjustify-content: center;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tuser-select: none;\n\tbackground: #eff3f8;\n\tcolor: #777;\n\n\t&:last-child {\n\t\tbackground: #2276e3;\n\t\tcolor: white;\n\t}\n"])));

var CONFIRM_CTA = {
  YES: 'Yes',
  NO: 'No'
};

var ConfirmDialog = function ConfirmDialog(_ref) {
  var onConfirm = _ref.onConfirm,
      ctaOrder = _ref.ctaOrder,
      heading = _ref.heading,
      description = _ref.description,
      shouldCloseOutsideClick = _ref.shouldCloseOutsideClick;
  var clientOnly = useHasMounted();

  var handleNo = function handleNo() {
    onConfirm({
      type: CONFIRM_CTA.NO
    });
  };

  var handleYes = function handleYes() {
    onConfirm({
      type: CONFIRM_CTA.YES
    });
  };

  var CTAs = [{
    lable: CONFIRM_CTA.YES,
    clickHander: handleYes
  }, {
    lable: CONFIRM_CTA.NO,
    clickHander: handleNo
  }];
  /*
    * To swap the Yes and No button order.
    * Yes and No cta positions are swappable but rightmost will be always selected
    */

  if (ctaOrder === 'n-y') {
    // default 'y-n'
    var _ref2 = [CTAs[1], CTAs[0]];
    CTAs[0] = _ref2[0];
    CTAs[1] = _ref2[1];
  }

  useEffect(function () {
    // fixed scrolling when bottom modal is opened
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.removeProperty('overflow');
    };
  }, []);
  return clientOnly ? /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalOverlay, {
    onClick: shouldCloseOutsideClick ? handleNo : function () {}
  }), /*#__PURE__*/React.createElement(ConfirmationModalContainer, null, /*#__PURE__*/React.createElement(TextContentDiv, null, /*#__PURE__*/React.createElement(ModalHeader, null, heading), description && /*#__PURE__*/React.createElement(ModalContent, null, description)), /*#__PURE__*/React.createElement(BtnWrapper, null, CTAs.map(function (v, i) {
    return /*#__PURE__*/React.createElement(Btn, {
      key: v.lable,
      onClick: v.clickHander,
      selected: i === 1
    }, v.lable);
  })))), document.body) : null;
};

ConfirmDialog.defaultProps = {
  ctaOrder: undefined,
  description: undefined,
  shouldCloseOutsideClick: undefined
};

export { CONFIRM_CTA, ConfirmDialog as default };
